import * as React from "react";
import Shop from "../../_data/models/Shop";
import {Link} from "react-router-dom";
import {ShopsRoutes} from "../../routes";

interface Props {
    shop: Shop;
    viewShop: (shop: Shop) => void;
    loadBooths: (shop: Shop) => void;

}

export const ShopBoothCountComponent = (props: Props)  => {

    const {shop, loadBooths} = props;

    if (!shop.boothCollection) {

        return (<td></td>);
    }

    else {
        return (
            <td>
                {shop.boothCollection.meta.totalCount + " booth" + (shop.boothCollection.meta.totalCount > 1 ? "s":"")}
            </td>
        );
    }
};

const ShopListItemComponent = (props: Props) => {

    const {shop, viewShop} = props;

    return (
        <li>
            <div className="media-object">
                <div className="media-object-section flushed middle">
                    <div className="img-wrapper small-img-fit">
                        <img src={shop.imageUrl()} />
                    </div>
                </div>
                <div className="media-object-section middle">
                    <div className="text-group">
                        <p><b>{shop.toString()}</b></p>
                        {/*<small className="subheader"><i className="fa fa-heart"></i>&nbsp; {shop.likeCount} Followers&nbsp;</small>*/}
                        <small className="subheader">{shop.address()}</small>
                    </div>
                </div>
            </div>
            <a href={ShopsRoutes.view(shop.id)} onClick={(e) => {e.preventDefault(); viewShop(shop);}} className="button primary pull-right">
                <i className="fa fa-eye-o"></i>&nbsp; View Shop Profile
            </a>
        </li>
    );
};

export default ShopListItemComponent;


// WEBPACK FOOTER //
// ./app/client/shop/components/ShopListItemComponent.tsx